import {Component, ElementRef, EventEmitter, OnInit, Output, ViewChild} from '@angular/core';

@Component({
    selector: 'lib-grid-calibration',
    templateUrl: './grid-calibration.component.html',
    styleUrls: ['./grid-calibration.component.scss']
})
export class GridCalibrationComponent implements OnInit {
    @Output() pointOver: EventEmitter<any> = new EventEmitter<any>();

    points = [
        {x: 0, y: 0}, {x: 50, y: 0}, {x: 100, y: 0},
        {x: 25, y: 25}, {x: 50, y: 25}, {x: 75, y: 25},
        {x: 0, y: 50}, {x: 25, y: 50}, {x: 75, y: 50}, {x: 100, y: 50},
        {x: 25, y: 75}, {x: 50, y: 75}, {x: 75, y: 75},
        {x: 0, y: 100}, {x: 50, y: 100}, {x: 100, y: 100},
    ];

    shafledPoins = [];
    @ViewChild('point') point: ElementRef;

    constructor() {

    }

    ngOnInit(): void {
        this.shuffleArray(this.points);
    }

    onPointOver(event) {
        this.updatePointPosition();
        this.pointOver.emit(event);
    }

    updatePointPosition() {
        const coordinates: { x: number, y: number } = this.getCoordinates();
        if (coordinates) {
            const el = this.point.nativeElement;
            el.setAttribute('style', 'top: ' + coordinates.y + '%; left:  ' + coordinates.x + '%');
        }
    }

    getCoordinates() {
        if (this.shafledPoins.length) {
            return this.shafledPoins.pop();
        } else {
            this.shuffleArray(this.points);
            return this.shafledPoins.pop();
        }
    }

    shuffleArray(targetArray: { x: number, y: number }[]) {
        const array = targetArray.map(a => {
            return {...a};
        });
        for (let i = array.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [array[i], array[j]] = [array[j], array[i]];
        }
        this.shafledPoins = array;
    }

}
